/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessGetShadowMCPInventoryServer } from "../funcs/accessGetShadowMCPInventoryServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ShadowMCPInventoryServer } from "../models/components/shadowmcpinventoryserver.js";
import {
  GetShadowMCPInventoryServerRequest,
  GetShadowMCPInventoryServerSecurity,
} from "../models/operations/getshadowmcpinventoryserver.js";
import { unwrapAsync } from "../types/fp.js";
export type ShadowMCPInventoryServerQueryData = ShadowMCPInventoryServer;

export function prefetchShadowMCPInventoryServer(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetShadowMCPInventoryServerRequest,
  security?: GetShadowMCPInventoryServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildShadowMCPInventoryServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildShadowMCPInventoryServerQuery(
  client$: GramCore,
  request: GetShadowMCPInventoryServerRequest,
  security?: GetShadowMCPInventoryServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ShadowMCPInventoryServerQueryData>;
} {
  return {
    queryKey: queryKeyShadowMCPInventoryServer({
      projectId: request.projectId,
      serverSlug: request.serverSlug,
      gramSession: request.gramSession,
    }),
    queryFn: async function shadowMCPInventoryServerQueryFn(
      ctx,
    ): Promise<ShadowMCPInventoryServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessGetShadowMCPInventoryServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyShadowMCPInventoryServer(
  parameters: {
    projectId: string;
    serverSlug: string;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "getShadowMCPInventoryServer", parameters];
}
